import Joyride, { STATUS } from 'react-joyride'
import JoyrideMessage from './JoyrideMessage'
import JoyrideStyles from './JoyrideStyles'

const steps = [
  {
    target: '#talent_profile_summary',
    content: (
      <JoyrideMessage
        title='Auf einen Blick'
        description='Hier siehst du eine kompakte Zusammenfassung der wichtigsten Fähigkeiten, Persönlichkeitsmerkmale, Werte und beruflichen Interessen des Talents.'
      />
    ),
    placement: 'bottom',
    disableBeacon: true
  }
]

const TalentProfileJoyride = ({ run, onClose }) => (
  <Joyride
    steps={steps}
    run={run}
    continuous
    showSkipButton
    showProgress
    styles={{
      ...JoyrideStyles,
      options: {
        zIndex: 10000,
        ...JoyrideStyles
      }
    }}
    locale={{
      last: 'Weiter',
      skip: 'Überspringen',
      next: 'Weiter',
      back: 'Zurück'
    }}
    callback={({ status }) => {
      if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        onClose?.()
      }
    }}
  />
)

export default TalentProfileJoyride
